export default __webpack_public_path__ + "static/first_test-9774fdc7ee65961d4ee3cb924ca05b8a.jpg";